<template>
    <div class="edit_price"  v-if="addOk">
        <el-card class="edit_price_account">
           <div slot="header" class="clearfix" style="text-align:center;">
                <span>{{deviceHead}}</span><span style="color:red">{{myCode}}</span>
            </div>
            <div class="editContent">
                <p>
                    <span class="e_left">价格：</span>
                    <el-input v-model="myPrice"></el-input>
                </p>
            </div> 
            <span @click="boxClose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
            <el-button type="success" @click="commitEditP" style="width:300px;margin-top:20px;">确认</el-button>
        </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      props: ['addShow', 'editDvceCode', 'editPrice'],
      data () {
        return {
          price: 0,
          point: 0,
          deviceCode: '',
          status: '',
          deviceHead: '设备编号'
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myCode: {
          get: function () {
            this.deviceCode = this.editDvceCode
            var a = this.deviceCode
            if (this.deviceCode === 0) {
              this.deviceHead = '全部设备'
              a = ''
            } else {
              this.deviceHead = '设备编号'
            }
            return a
          },
          set: function (val) {
            this.deviceCode = val
          }
        },
        myPrice: {
          get: function () {
            this.price = this.editPrice
            return this.editPrice
          },
          set: function (val) {
            this.price = val
          }
        }
      },
      methods: {
        boxClose () {
          this.$emit('closeEditPrice', false)
        },
        commitEditP () {
          var _this = this
          var params = {
            deviceCode: _this.deviceCode + '',
            charge: Number(_this.price)
          }
          $axios.post('/userChargeConfig/update', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$message({
                type: 'success',
                duration: 1000 * 1,
                message: '修改价格成功!'
              })
              _this.boxClose()
            } else {
              _this.$message({
                type: 'error',
                duration: 1000 * 1,
                message: '修改价格失败!' + res.errorMessage
              })
            }
          })
        }
      }
    }
</script>
<style lang="scss">
  .edit_price{
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  
      .edit_price_account {
        min-height: 230px;
        width: 500px;
        top: 29%;
        left: 50%;
        z-index: 101;
        margin-left: -200px;
        position: fixed;

        .editContent {
          text-align: left;
          margin-left: 30px; 

          .el-input{
            width: 300px;
          }
          .e_left {
              width: 20%;
              display: inline-block;
          }
        }
      }
  }
</style> 


// WEBPACK FOOTER //
// src/page/deviceMgr/editPrice.vue